// removed by extract-text-webpack-plugin
module.exports = {"base":"MembersControlBlock_base--Ci7di","icon":"MembersControlBlock_icon--mLCog","icon__changeRole":"MembersControlBlock_icon__changeRole--2_fOb","iconChangeRole":"MembersControlBlock_icon__changeRole--2_fOb","icon__allocateTreasury":"MembersControlBlock_icon__allocateTreasury--Nnhax","iconAllocateTreasury":"MembersControlBlock_icon__allocateTreasury--Nnhax","icon__removeMembers":"MembersControlBlock_icon__removeMembers--3Gr55","iconRemoveMembers":"MembersControlBlock_icon__removeMembers--3Gr55","isDisabled":"MembersControlBlock_isDisabled--1ObZX"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanManagement/components/MembersControlBlock/MembersControlBlock.scss
// module id = 2390
// module chunks = 11